
module.exports = [
	{
		code: 'health_status_main',
		name: 'Gesundheitsstatus'
	}, {
		code: 'health_status_extra',
		name: 'Gesundheitsstatus extra Angaben'
	}, {
		code: 'weight_class',
		name: 'Gewichtsklasse'
	}, {
		code: 'show_in_poultry_search',
		name: 'In Geflügelsuche anzeigen'
	}
]
